import React from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import OperateTitle from '@/pages/Maintenance/Executive/components/OperateTitle';
import Descriptions from '@/components/Descriptions';

function Summary({ currentLib, currentEnv, currentCluster, title, currentHosts }) {
  const [searchParams] = useSearchParams();
  const clusterType = Number(searchParams.get('clusterType'));
  const k8sHost = currentHosts[0] || {};

  return (
    <Root>
      <OperateTitle title={title} />
      <Descriptions style={{ padding: '12px 20px 6px' }}>
        <Descriptions.Item label='组件名称' value={searchParams.get('name')} />
        <Descriptions.Item label='执行环境' value={currentEnv.envName} />
        <Descriptions.Item label='执行集群' value={currentCluster.name} />
        <Descriptions.Item label='目标版本' value={currentLib.version} />
      </Descriptions>
      {clusterType === 1 && (
        <Descriptions title='K8s集群信息' style={{ padding: '0 20px 12px' }}>
          <Descriptions.Item label='K8s集群名称' value={k8sHost.kubeName} />

          <Descriptions.Item label='终端地址' value={k8sHost.serviceIp || k8sHost.hostIp} />

          {k8sHost.hostUser && <Descriptions.Item label='SSH用户' value={k8sHost.hostUser} />}

          {k8sHost.currentVersion && (
            <Descriptions.Item label='当前版本' value={k8sHost.currentVersion} />
          )}
        </Descriptions>
      )}
    </Root>
  );
}

export default connect((state) => ({
  currentLib: state.execComponent.currentLib,
  currentEnv: state.execComponent.currentEnv,
  currentCluster: state.execComponent.currentCluster,
  currentHosts: state.execComponent.currentHosts,
}))(Summary);

const Root = styled.div`
  border-radius: 8px;
  border: 1px solid #e1e1e1;
  margin-bottom: 16px;
`;
